type ProductNameSource = {
  tallyPlatformProduct?: { name: string } | null;
  items: ReadonlyArray<{
    platformProductsLength: { platformProduct: { name: string } };
  }>;
};

export function requestForQuoteProductName(
  requestForQuote: ProductNameSource
): string | null {
  if (requestForQuote.tallyPlatformProduct) {
    return requestForQuote.tallyPlatformProduct.name;
  }
  const names = new Set(
    requestForQuote.items.map(
      (item) => item.platformProductsLength.platformProduct.name
    )
  );
  return names.size === 1 ? [...names][0] : null;
}
